import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  GLOBAL_STATE,
  VACATION_PUBLIC_INFO,
  VACATION_REQUEST_DOWNLOAD,
  VACATION_REQUEST_LIST,
} from '../constants/actionTypes'

const Selectors = (state: RootState) => prop(GLOBAL_STATE, state)

export const vacationDownloadSelector = createSelector(Selectors, prop(VACATION_REQUEST_DOWNLOAD))

export const vacationListSelector = createSelector(Selectors, prop(VACATION_REQUEST_LIST))

export const vacationPublicInfoSelector = createSelector(Selectors, prop(VACATION_PUBLIC_INFO))
